import '.bn{position:relative;}.ssr-plugin'
import '.ae{background-color:var(--shades-white);}.ssr-plugin'
import '.hp{border-radius:20px;}.ssr-plugin'
import '.aq{border:var(--blue-border);}.ssr-plugin'
import '.bw{padding:1.5rem;}.ssr-plugin'
import '.t{width:100%;}.ssr-plugin'
import '.in{transition:box-shadow 0.2s ease;}.ssr-plugin'
import '.gg{width:2rem;}.ssr-plugin'
import '.gh{height:2rem;}.ssr-plugin'
import '.ds{border-radius:50%;}.ssr-plugin'
import '.io{border:1px solid var(--shades-blue-800);}.ssr-plugin'
import '.g{display:flex;}.ssr-plugin'
import '.i{justify-content:center;}.ssr-plugin'
import '.b{align-items:center;}.ssr-plugin'
import '.bp{flex-shrink:0;}.ssr-plugin'
import '.ip{margin-left:1rem;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Text } from '@app/components/core/typography/Text'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUpRight } from '@fortawesome/pro-regular-svg-icons'
import Row from '@app/components/layout/Row'
import Column from '@app/components/layout/Column'
import { Title } from '@app/components/core/typography/Title'

export interface SubsidyCardProps {
  title: string
  description: string
  style?: Style
  onClick?: () => void
}

export const SubsidyCard = ({
  title,
  description,
  style,
  onClick,
}: SubsidyCardProps) => {
  return (
    <styled.div className="bn ae hp aq bw t in"
      data-testid="subsidy-card"
      onClick={onClick}
      style={{
        cursor: onClick ? 'pointer' : 'default',
        '&:hover': onClick
          ? {
              boxShadow: '0 4px 14px 0 rgba(0, 0, 0, 0.08)',
            }
          : {},
        ...style,
      }}
    >
      <Column gap="0.625rem" alignItems="stretch">
        {/* Header Section */}
        <Row
          style={{
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          {/* Title */}
          <Title.H5 style={{ color: 'var(--shades-blue-800)' }}>
            {title}
          </Title.H5>

          {/* Circular Icon */}
          <div className="gg gh ds io g i b bp ip"
          >
            <FontAwesomeIcon
              icon={faArrowUpRight}
              style={{
                color: 'var(--shades-blue-800)',
                height: '1.25rem',
              }}
            />
          </div>
        </Row>

        {/* Body Section */}
        <Text.Medium
          style={{
            color: 'var(--shades-blue-600)',
          }}
        >
          {description}
        </Text.Medium>
      </Column>
    </styled.div>
  )
}
